import React, { memo, useEffect, useRef, useState } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';
import captureEscKeyListener from '../../util/captureEscKeyListener';

import useLang from '../../hooks/useLang';
import useUniqueId from '../../hooks/useUniqueId';

import tooltipStyles from '../ui/IconWithTooltip.module.scss';
import styles from './SettingsMetadata.module.scss';

function MetadataSharingHelp() {
  const lang = useLang();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>();
  const id = useUniqueId();
  useEffect(() => isOpen ? captureEscKeyListener(() => setIsOpen(false)) : undefined, [isOpen]);
  useEffect(() => {
    if (!isOpen) return undefined;
    const close = (event: Event) => {
      if (!ref.current?.contains(event.target as Node)) setIsOpen(false);
    };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [isOpen]);
  return (
    <div ref={ref} className={styles.help} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <button
        type="button"
        className={buildClassName(styles.iconButton, styles.sectionButton)}
        aria-label={lang('Help')}
        aria-expanded={isOpen}
        aria-describedby={isOpen ? id : undefined}
        onClick={() => setIsOpen(true)}
      >
        <i className={buildClassName(tooltipStyles.icon, tooltipStyles.small, 'icon-question')} aria-hidden />
      </button>
      {isOpen && (
        <div
          id={id}
          role="tooltip"
          className={buildClassName(tooltipStyles.tooltip, tooltipStyles.small, styles.helpBubble)}
        >
          {lang('$metadata_linked_wallets_help')}
        </div>
      )}
    </div>
  );
}

export default memo(MetadataSharingHelp);
